module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('solicitacao-boleto', {
    attrs: {
      "solicitacao": _vm.solicitacao
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1c3c0eea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atendimentos/comuns/impressaoBoleto.vue
// module id = 810
// module chunks = 0